import { atom } from "recoil";

export const customizeState = atom({
  key: "customize",
  default: false,
});
